import { useState } from 'react';

export function useFilterText(initialFilter = ''): [string, (newValue: string) => void] {
  const [filterText, setFilterText] = useState(initialFilter);

  return [filterText, setFilterText];
}
